import { Component, ViewChild } from '@angular/core';
import { AuthService } from '../../../../@core/services/auth.service';
import { PedidoService } from '../../../../@core/services/pedido.service';
import { environment } from '../../../../../../src/environments/environment';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LoadingComponent } from '../../../../@theme/components/loading/loading.component';

@Component({
    selector: 'app-consultar-pedido-modal',
    templateUrl: './consultar-pedido-modal.component.html',
    styleUrls: ['./consultar-pedido-modal.component.scss'],
    standalone: false
})
export class ConsultarPedidoModalComponent {
  @ViewChild('appLoading') public loading: LoadingComponent;

  public production: boolean = false;
  public dadosPedidoItens: Array<any>;
  public listaParaMostrar: Array<any> = [];
  public form: UntypedFormGroup;
  public empresa: string;
  public user: any;

  constructor(
    private authService: AuthService,
    private pedidoService: PedidoService,
    private formBuilder: UntypedFormBuilder
  ) {
    this.production = environment.production;

    this.form = this.formBuilder.group({
      IdCompany: [0],
      NumeroDoPedido: [0],
      NumeroDoPedidoSiscort: [0],
      Ano: [0],
      ExternalNameClienteComIdSiscort: [''],
      EmergenciaDesc: [''],
      TransportadoraDesc: [''],
      TipoDeUtilizacaoDesc: [''],
      EmailCriadoPor: [''],
      TipoDeRemessaDesc: ['']
    });
  }

  public linhasTIC: Array<any> = [
    {
      key: "FI",
      value: "Fiação"
    },
    {
      key: "FT",
      value: "Fita"
    },
    {
      key: "GA",
      value: "Gaxeta"
    },
    {
      key: "PH",
      value: "Papelão Hidraulico"
    },
    {
      key: "PI",
      value: "Papelão Industrial"
    },
    {
      key: "PL",
      value: "Placa"
    },
    {
      key: "RV",
      value: "Revenda"
    },
    {
      key: "ST",
      value: "Sintetico"
    },
    {
      key: "TE",
      value: "Tecelagem"
    }];
  public linhasTJ: Array<any> = [
    {
      key: "JC",
      value: "Juntas Cortadas"
    },
    {
      key: "MT",
      value: "Metalflex"
    },
    {
      key: "MB",
      value: "Metalbest"
    },
    {
      key: "FX",
      value: "FreeFlex"
    },
    {
      key: "RJ",
      value: "Ring Joint"
    },
    {
      key: "PE",
      value: "Produtos Especiais"
    },
    {
      key: "TT",
      value: "Termatic"
    },
    {
      key: "SV",
      value: "Serviços"
    },
    {
      key: "EQ",
      value: "Equipamentos"
    }];

  ngOnInit(): void {
    this.user = this.authService.getClaims();
  }

  clear(): void {
    this.dadosPedidoItens = [];
  }

  getPedido() {
    this.loading.open();

    if (this.form.value.NumeroDoPedido == null)
      this.form.value.NumeroDoPedido = 0;

    if (this.form.value.Ano == null)
      this.form.value.Ano = 0;

    if (this.form.value.NumeroDoPedidoSiscort == null)
      this.form.value.NumeroDoPedidoSiscort = 0;

    this.pedidoService.getByNumeroOuNumeroSiscort(this.form.value.NumeroDoPedido, this.form.value.Ano, this.form.value.NumeroDoPedidoSiscort)
      .subscribe(response => {
        this.loading.close();

        if (response != null) {
          this.dadosPedidoItens = response.ItensOrdenados;
          this.form.patchValue(response);
        } else {
          this.dadosPedidoItens = [];
          this.form.reset();
        }
      });
  }
}
